// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"d63a5e7f","326":"f9b4fb88"}[chunkId] + ".chunk.css";
};